var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},_vm._l((_vm.vehiculos),function(vehiculo,index){return _c('v-col',{key:index,attrs:{"xs":"12","sm":"12","xl":"3","md":"4","lg":"4"}},[_c('Vehiculo',{attrs:{"vehiculo":vehiculo,"vehiculos":_vm.vehiculos}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }